import XLSX from 'xlsx';

export const thousandSeparator = (number) => {
    let parts = number.toString().split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return parts.join(',');
}

export const isImageFile = (filename) => {
    const extention = getExtentionFile(filename);
    return /(jpe?g|jpg|png|gif|bmp)$/i.test(extention);
}

export const getExtentionFile = (filename) => {
    return (filename.match(/\.([^.]*?)(?=\?|#|$)/) || [])[1];
}

export const validateFile = (filetype) => {
    let valid = false;
    const splitFile = filetype.split('/');
    if (/(jpe?g|jpg|png|gif|bmp)$/i.test(splitFile[1])) {
        valid = true
    } else if (/(pdf)$/i.test(splitFile[1])) {
        valid = true
    }
    return valid;
}

export const loanStatus = (id) => {
    let status = '';
    switch (id) {
        case 1:
            status = 'Draf';
        break;
        case 2:
            status = 'Underwriting';
        break;
        case 3:
            status = 'Pre-Fund';
        break;
        case 4:
            status = 'Approve';
        break;
        case 5:
            status = 'Active';
            break;
        case 6:
            status = 'Closed';
            break;
        case 7:
            status = 'Cancelled';
            break;
        case 8:
            status = 'Declined';
            break;
        default:
            status = ''
    }
    return status;
}

export const exportToExcel = (data) => {
    let fileFormat = ".xlsx";
    let result = [];
    let temp = [];
    let tempHead = [];
    for (let count = 0; count < data.length; count++) {
        temp = [];
        for (let prop in data[count]) {
            if (count === 0) {
                temp.push(data[count][prop]);
                tempHead.push(prop);
            } else {
                temp.push(data[count][prop]);
            }
        }
        if (count === 0) {
            result.push(tempHead);
            result.push(temp);
        } else {
            result.push(temp);
        }
    }
    const worksheet = XLSX.utils.aoa_to_sheet(result);
    let newWorkbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(newWorkbook, worksheet, "Sheet");
    XLSX.writeFile(newWorkbook, "export" + Date.now() + fileFormat);
}

export const isLastRow = (index, totalPage) => {
    return index === totalPage - 1;
}

export const productIdentifier = (productId) => {
    let endpoint = '';
    switch (productId) {
        case '570f91ea-412b-11eb-99d9-00163e01a609':
            endpoint = '/tokutei_gino_loan';
        break;
        case '19a80828-ec60-11ec-8431-00163e01a609':
            endpoint = '/trainee_loan';
        break;   
        case '35831e74-408a-11ed-8ab8-00163e01a609':
            endpoint = '/advance_disburse';
        break;  
        default:
            endpoint = '/education_loan';
    }
    return endpoint;
}

export const isProductTokutei = (productId) => {
return productId === '570f91ea-412b-11eb-99d9-00163e01a609';
}